import { EMOTE_SPEECH_LINE_KEYS } from '../locales/emoteSpeechCatalog';

/**
 * @param {string} unlockKey - unlock_catalog.unlock_key for emote rows
 * @param {import('i18next').TFunction} t - react-i18next `t`
 * @returns {string} Localized speech line for Profile / BattleUI bubbles
 */
export function getTranslatedEmoteSpeech(unlockKey, t) {
  if (typeof unlockKey !== 'string' || !unlockKey.trim()) {
    throw new Error('getTranslatedEmoteSpeech: unlockKey is required');
  }
  if (!EMOTE_SPEECH_LINE_KEYS.includes(unlockKey)) {
    throw new Error(`Unknown emote unlock_key for i18n: ${JSON.stringify(unlockKey)}`);
  }
  const key = `profile.emotes.lines.${unlockKey}`;
  const out = t(key);
  if (out === key) {
    throw new Error(`Missing i18n translation for emote speech: ${key}`);
  }
  return out;
}

/** Two-word lines for speech bubble layout (battle + opponent bubble). */
export function formatEmoteBubbleTwoWords(text) {
  if (typeof text !== 'string') {
    throw new Error('formatEmoteBubbleTwoWords: text must be a string');
  }
  const words = text.split(/\s+/).filter(Boolean);
  const lines = [];
  for (let i = 0; i < words.length; i += 2) {
    lines.push(words.slice(i, i + 2).join(' '));
  }
  return lines.join('\n');
}

/**
 * @param {{ emoteKey?: string, text?: string } | null | undefined} bubble
 * @param {import('i18next').TFunction} t
 */
export function resolveBattleEmoteBubbleDisplay(bubble, t) {
  if (!bubble) return '';
  if (bubble.emoteKey) {
    return getTranslatedEmoteSpeech(bubble.emoteKey, t);
  }
  if (bubble.text != null && bubble.text !== '') {
    return String(bubble.text);
  }
  throw new Error('Battle emote bubble must have emoteKey or non-empty text');
}
